import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  options: [],
  error: null,
};

const { Types, Creators } = createActions(
  {
    getCouponRangeList: [],
    getCouponRangeListRequest: [],
    getCouponRangeListSuccess: ['data'],
    getCouponRangeListFailure: ['error'],
  },
  { prefix: 'cb/couponRangeList/' },
);

export { Types as types, Creators as actions };

const getCouponRangeListRequest = (state = INITIAL_STATE) => ({
  ...state,
  fetching: true,
  error: INITIAL_STATE.error,
});

const getCouponRangeListSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  fetching: false,
  fetched: true,
  options: action.data,
});

const getCouponRangeListFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  fetching: false,
  fetched: false,
  error: action.error,
});

export const HANDLERS = {
  [Types.GET_COUPON_RANGE_LIST_REQUEST]: getCouponRangeListRequest,
  [Types.GET_COUPON_RANGE_LIST_SUCCESS]: getCouponRangeListSuccess,
  [Types.GET_COUPON_RANGE_LIST_FAILURE]: getCouponRangeListFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
